'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useRouter } from '@/core/i18n/navigation';
import { ScrollArea, ScrollBar } from '@/shared/components/ui/scroll-area';
import { Tabs as TabsComponent, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';
import { cn } from '@/shared/lib/utils';
import { Tab } from '@/shared/types/blocks/common';
export function Tabs(t0) {
  const $ = _c(22);
  const {
    tabs,
    size
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== tabs) {
    t1 = tabs?.find(_temp)?.name || "";
    $[0] = tabs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [tabName, setTabName] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useState(t2 as Tab);
  let t3;
  if ($[3] !== router || $[4] !== tabName || $[5] !== tabs) {
    t3 = () => {
      if (tabName) {
        const currentTab = tabs?.find(tab_1 => tab_1.name === tabName) || {} as Tab;
        if (currentTab.url) {
          router.push(currentTab.url);
        }
      }
    };
    $[3] = router;
    $[4] = tabName;
    $[5] = tabs;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== tabName) {
    t4 = [tabName];
    $[7] = tabName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  const t5 = size === "sm" && "h-8";
  let t6;
  if ($[9] !== t5) {
    t6 = cn(t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== tabs) {
    t7 = tabs.map(_temp2);
    $[11] = tabs;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <TabsList className={t6}>{t7}</TabsList>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8 || $[17] !== tabName) {
    t9 = <div className="flex items-center space-x-2"><TabsComponent value={tabName} onValueChange={setTabName}>{t8}</TabsComponent></div>;
    $[16] = t8;
    $[17] = tabName;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ScrollBar orientation="horizontal" className="invisible" />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t9) {
    t11 = <div className="relative mb-8"><ScrollArea className="w-full lg:max-w-none">{t9}{t10}</ScrollArea></div>;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}
function _temp2(tab_2, idx) {
  return <TabsTrigger key={idx} value={tab_2.name || ""}>{tab_2.title}</TabsTrigger>;
}
function _temp(tab) {
  return tab.is_active;
}